module.exports = __webpack_public_path__ + "static/media/home-banner-web.7ab006ff.png";